var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"bm-header"},[_c('div',{attrs:{"id":"content"}},[_c('p',[_vm._v("For more information, download the "),_c('a',{attrs:{"href":"https://www.svmicrowave.com/sites/default/files/documents/Cable_Builder_App_Note_V2.pdf"}},[_vm._v("Rapid Response Application Note")]),_vm._v(". Cable assemblies typically ship in 15 business days.")])])])])
}]

export { render, staticRenderFns }